import React from 'react';
import * as _ from 'lodash';
import {
  FormElement,
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';
import { CraneService } from '../../../services/Cranes';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import { REQUEST_PARAMS } from '../../../utilities/constants';
import { messageUtility } from '../../../utilities/messageUtility';

import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
// import { ClearIcon } from '../../icons/ClearIcon';

/**
 * 揚重機マスタ単一選択ドロップダウン
 */
export class CraneDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      loaded: false, // ロード完了フラグ
      allLoaded: false,
      opened: false, // 開閉フラグ
      options: [], // 揚重機マスタ一覧
      condition: {
        // 検索条件
        name: '',
      },
      page: 0, // offset用
      selected: null, // 選択協力会社情報(id)
      selectedName: '', // 選択協力会社情報(name)
      temporarySelected: null, // 選択協力会社情報temp(id)
      temporarySelectedName: '', // 選択協力会社情報temp(id)
      isLoading: true, // ロード中フラグ
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this); // 検索
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.setCondition = this.setCondition.bind(this); // 検索条件をセット
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリック
    this.getCranes = this.getCranes.bind(this); // 揚重機マスタ取得
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    this.getCranes();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // 初期値が設定されていた場合はselectedへセット
    if (nextProps.value !== prevState.selected) {
      return {
        selected: nextProps.value,
        selectedName: nextProps.name || '',
        temporarySelected: nextProps.value,
        temporarySelectedName: nextProps.name || '',
      };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });

    // フォーカスアウト時のバリデーション
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  /**
   * 開閉イベント
   */
  handleOpen = () => {
    // 初期化
    let { opened, selected, selectedName } = { ...this.state };
    if (opened === false) {
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState({
        opened: true,
        loaded: true,
        temporarySelected: selected,
        temporarySelectedName: selectedName,
      });
    } else {
      this.setState({ opened: false });
      // フォーカスアウト時のバリデーション
      if (_.isFunction(this.props.validate)) {
        this.props.validate(this.props.column);
      }
    }
  };

  /**
   * 検索条件セット
   */
  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  /**
   * 検索
   */
  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        page: 0,
        isLoading: true,
      },
      () => {
        this.getCranes();
      }
    );
  };

  handleInview() {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState(
        {
          loaded: false,
        },
        () => {
          this.getCranes();
        }
      );
    }
  }

  /**
   * 選択肢をクリック
   * @param id {int}
   * @param checked {bool} 選択・未選択判定
   */
  handleSelectedRow = id => {
    const { options } = this.state;
    const selectedRow = _.find(options, { id });
    this.setState(
      {
        temporarySelected: id,
        temporarySelectedName: selectedRow.name,
      },
      () => {
        this.setValue();
      }
    );
  };

  clearSelectedRow = () => {
    this.setState({ selected: null, selectedName: '', opened: false }, () => {
      this.props.set('crane_id', null);
    });
  };

  /**
   * 「選択」押下時
   *
   * @memberof CraneDropdown
   */
  setValue = () => {
    let { temporarySelected, temporarySelectedName } = this.state;
    this.setState({
      selected: temporarySelected,
      selectedName: temporarySelectedName,
      opened: false,
    });

    if (_.isFunction(this.props.set)) {
      this.props.set(this.props.column, temporarySelected);
    }
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column, { crane_id: temporarySelected });
    }
  };

  /**
   * 揚重機マスタ取得
   */
  getCranes() {
    if (this.state.loaded) {
      this.setState({ isLoading: false });
      return;
    }
    const params = {
      field_id: this.state.fieldId,
      limit: REQUEST_PARAMS.parentLimit,
      offset: this.state.page * REQUEST_PARAMS.parentLimit,
      name: this.state.condition.name,
      isQuiet: true,
    };

    CraneService.list(this.state.fieldId, params).then(response => {
      if (response.result === false) {
        return;
      }
      const _data = response.data.entities.cranes;
      const allLoaded = _.size(_data) < params.limit;
      const data = _.filter(_data, { display_flag: 1 });
      const options = this.state.options;
      const sorted = _.orderBy(
        data,
        ['order_number', 'updated_at'],
        ['asc', 'desc']
      );
      _.each(sorted, option => {
        if (_.findIndex(options, { id: option.id }) < 0) {
          options.push(option);
        }
      });

      this.setState({
        options,
        loaded: true,
        allLoaded,
        page: this.state.page + 1,
        isLoading: false,
      });
    });
  }

  render() {
    const isOptional = this.props.isOptional;
    const getName = () => {
      let name = '使用揚重機を選択';
      const option = _.find(this.state.options, {
        id: this.state.selected,
      });
      if (!_.isUndefined(option)) {
        name = option.name;
      } else {
        name = this.state.selectedName || name;
        if (this.props.readOnly && !this.state.selectedName) {
          name = '';
        }
      }

      return name;
    };
    const getClassName = () => {
      let className = 'modal-dropdown dropdown--dropdown-list';
      if (this.state.opened === true) {
        className += ' show';
      }
      if (this.props.isDisableTime) {
        className += ' modal-dropdown--disable-time';
      }
      return className;
    };
    if (this.props.isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div>{getName()}</div>
        </FormElement>
      );
    }
    return (
      <FormElement validate={this.props.error}>
        <div id='form-dropdown' className='dropdown-multi-select'>
          {this.props.readOnly ? (
            <input disabled type='text' value={getName()} />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-multi-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  className='dropdown-select'
                  onClick={this.handleOpen}
                >
                  <span className='dropdown-select__txt'>{getName()}</span>
                </div>
              </div>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              {this.state.opened && (
                <div id='form-dropdown-list' className={getClassName()}>
                  <div
                    className={`dropdown__item ${
                      !_.isUndefined(this.props.widthClass)
                        ? this.props.widthClass
                        : 'dropdown__item--wide'
                    } dropdown__item--hidden`}
                  >
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    {isOptional && (
                      <div className='dropdown-single-select__item'>
                        <FormDropdownClearButton
                          onClick={this.clearSelectedRow}
                        />
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected === option.id
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-field-crane-id'
                            />
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.handleInview}
                            ignoreIndicator={true}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/Crane.jsx